/**
 * Employee display helpers — preferred/known-as vs legal name.
 */
import type { Employee } from '@shared/types';

/** Preferred / known-as name used everywhere in the UI. */
export function employeeDisplayName(
  e: Pick<Employee, 'name'> | { name: string },
): string {
  return e.name;
}

/** Legal name when it differs from the preferred display name. */
export function employeeLegalName(
  e: Pick<Employee, 'name' | 'legalName'>,
): string | null {
  const legal = e.legalName?.trim() || null;
  if (!legal) return null;
  if (legal.toLowerCase() === e.name.trim().toLowerCase()) return null;
  return legal;
}

export function employeeNameWithLegal(
  e: Pick<Employee, 'name' | 'legalName'>,
): string {
  const legal = employeeLegalName(e);
  return legal ? `${e.name} (legal: ${legal})` : e.name;
}
